<app-announcement-banner (bannerValue)="onBannerValueChange($event)" [currentUser]="currentUser"></app-announcement-banner>
<div [ngClass]="{ 'banner-open': isbanneropen }" class="dashboard-wrapper"> 
<div class="container task">
  <div class="set">
    <div class="sidebar-search">
      <mat-form-field appearance="outline" style="width: 285px;margin-left: -3px;">
        <input
          matInput
          type="text"
          #filter
          (keyup)="applyFilter($event)"
          placeholder="Search Project/Task Name"
          [(ngModel)]="filterName"
          class="no-outline"
        />
        <button
          mat-stroke-button
          matSuffix
          (click)="filter.focus()"
          style="background-color: #1059a91a"
          class="icon-search-button"
        >
          <mat-icon class="icon-search">search</mat-icon>
        </button>
      </mat-form-field>

      <div class="filter-panel" (click)="toggleFilterPanel()" fxlayoutGap="5px">
        <mat-icon class="icon-filter" matTooltip="Filters">tune</mat-icon>
      </div>
      </div>

      <div class="tabset">
        <!-- Tab 1 -->
        <input
        type="radio"
        name="tabset"
        id="recent"
        aria-controls="marzen"
        checked
        (change)="onItemChange($event.target)"
      />
      <label for="recent">Recent</label>
      <!-- Tab 2 -->
      <input
        type="radio"
        name="tabset"
        id="received"
        aria-controls="rauchbier"
        (change)="onItemChange($event.target)"
      />
      <label for="received">Completed</label>
      <!-- Tab 3 -->
      <input
        type="radio"
        name="tabset"
        id="canceled"
        aria-controls="dunkles"
        (change)="onItemChange($event.target)"
      />
      <label for="canceled">Inactive</label>
      <!-- Tab 4 -->
      <input
        type="radio"
        name="tabset"
        id="all"
        aria-controls="luese"
        (change)="onItemChange($event.target)"
      />
      <label for="all">All</label> 
   </div>

    <div class="btns">
      <a fxHide.lt-md [class.disabled]="noTaskCreatePermission" [attr.aria-disabled]="noTaskCreatePermission"
        (click)="!noTaskCreatePermission ? trackNewClick('desktop') : null" class="add">
        <span class="material-icons-outlined"> add </span>New
      </a>
      <a fxHide fxShow.lt-md class="add" (click)="trackNewClick('mobile')">
        <span class="material-icons-outlined"> add </span>New
      </a>
    </div>
  </div>
  
  <div [ngClass]="{'show-filter': isFilterPanelExpanded}" class="filter-container" style="display: flex;">
    <div fxLayoutGap="10px" fxLayout="row"  fxLayoutAlign="center center">
      <div class="head-menu" [matMenuTriggerFor]="menu" style="cursor: pointer;width: 188px;">
        <span class="menu-item">{{this.projectName ? this.projectName : 'Filter by Project Name'}}</span>
        <mat-icon class="material-icons-outlined">
          expand_more
        </mat-icon>
      </div>
      <mat-menu #menu="matMenu" class="collection-list-menu filter-mat-menu">
        <div class="collection-buttons" *ngFor="let projects of projectData">
          <button mat-menu-item (click)="selectProject(projects)">
            <span [matTooltip]="projects?.project?.length > 20 ? projects?.project : ''">{{
              projects?.project }}</span></button>
        </div>
      </mat-menu>

      <div *ngIf="selectedProjectId" class="head-menu" [matMenuTriggerFor]="task" style="cursor: pointer;width: 188px;">
        <span class="menu-item">{{this.taskName ? this.taskName : 'Filter by Task Name'}}</span>
        <mat-icon class="material-icons-outlined">
          expand_more
        </mat-icon>
      </div>
      <div *ngIf="!selectedProjectId" class="head-menu" style="width: 188px;">
        <span class="menu-item">{{this.taskName ? this.taskName : 'Filter by Task Name'}}</span>
        <mat-icon class="material-icons-outlined">
          expand_more
        </mat-icon>
      </div>
      <mat-menu #task="matMenu" class="collection-list-menu filter-mat-menu">
        <div class="collection-buttons" *ngFor="let tasks of taskList">
          <button mat-menu-item (click)="selectTask(tasks)">
            <span [matTooltip]="tasks?.taskName?.length > 20 ? tasks?.taskName : ''">{{
              tasks?.taskName }}</span></button>
        </div>
      </mat-menu>

      <div class="head-menu" [matMenuTriggerFor]="statusMenu" style="cursor: pointer;width: 188px;">
        <span class="menu-item">{{this.selectedStatusLabel ? this.selectedStatusLabel : 'Filter by Status'}}</span>
        <mat-icon class="material-icons-outlined">
          expand_more
        </mat-icon>
      </div>
      <mat-menu #statusMenu="matMenu" class="collection-list-menu filter-mat-menu">
        <div class="collection-buttons" *ngIf="availableStatuses.length > 1">
          <button mat-menu-item (click)="selectStatus('all')">
            <span>All</span>
          </button>
        </div>
        <div class="collection-buttons" *ngFor="let item of availableStatuses">
          <button mat-menu-item (click)="selectStatus(item.value)">
            <span>{{item.label}}</span>
          </button>
        </div>
      </mat-menu>

        <mat-icon class="icon-filter material-icons-outlined" [ngClass]="{'icon-filter-disable': (!selectedProjectId && !selectedTaskId && !selectedStatus && !selectedStatusLabel)}"
        (click)="clearFilter()" [matTooltip]="(selectedProjectId || selectedTaskId || selectedStatus || selectedStatusLabel) ? 'Clear filters' : '' ">restart_alt</mat-icon>
    </div>
  </div>

  <!-- <div style="color: red;font-size: 17px;
    font-weight: 700; margin-bottom: -11px;">
    Alert: The platform will undergo updates on Monday, March 10th, between 8:30 and 13:30 UTC. During this period, you should avoid ordering a task. You can still task or receive your captures. You can work with your existing collections.
  </div> -->

  <div>
    <div class="card mt-4" *ngIf="tableDataLength > 0">
      <mat-card class="mat-head">
        <span>Tasks</span>
        <span style="font-size: 12px"
          >Please use the 'Proceed to Pay' option if your approved tasks are
          within the next 24hrs.
        </span>
      </mat-card>
    </div>
    <div class="tab-panels scrollbar" id="scrollcustom" [ngClass]="{'scrollbar-banner-expanded' : isFilterPanelExpanded && isbanneropen,'scrollbar-expanded' : isFilterPanelExpanded, 'scrollbar-banner-open': isbanneropen }"
      appScrollTracker (scrolledBottom)="loadMoreData()">
      <section class="tab-panel">
        <table
          *ngIf="tableDataLength > 0"
          mat-table
          [dataSource]="dataSource"
          matSort
          (matSortChange)="announceSortChange($event)"
          class="mat-elevation-z8 cs-my-task"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="position">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by number"
              style="padding-right: 1.5%;"
            >
              Project Name
            </mat-header-cell>

            <mat-cell
              class="frequency-cell"
              *matCellDef="let element"
              [style.color]="color"
              style="padding-right: 1.5%;"
            >
              <span
                [matTooltip]="
                  element?.project?.length > 12 ? element?.project : ''
                "
                >{{ element.project }}</span
              >
      <img
        *ngIf="element?.taskStrategy === 'Feed Based' && !currentUser?.allocated && !currentUser?.cpc"
        src="../../../assets/images/sat-earth.png"
        alt="Question Based"
        class="custom-feed-icon"
        matTooltip="Question Based"
      />
      <mat-icon 
        *ngIf="element?.taskStrategy !==  'Feed Based' && !currentUser?.allocated && !currentUser?.cpc" 
        style="font-size: 18px; margin-top: 5px;" 
        matTooltip="Sensor Based"
        class="custom-task-icon">
        sensors
     </mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="taskname">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by name"
              style="padding-right: 1%"
            >
              Task Name
            </mat-header-cell>
            <mat-cell class="frequency-cell" *matCellDef="let element"
            style="padding-right: 1%"
            >
              <span
                [matTooltip]="
                  element?.taskname?.length > 12 ? element?.taskname : ''
                "
                >{{ element.taskname }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createddate">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by symbol"
              class="align"
              style="width: 285px;"
            >
            Submission Date <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span>
            <mat-icon
            class="clock-icon"
            matSuffix
            matTooltip="Use the clock to set the preferred time scale on this page: UTC or registered time."
            (click)="convertTime($event)"
            >schedule</mat-icon>
            </mat-header-cell>
            <mat-cell class="frequency-cell" *matCellDef="let element"
            class="align"
            >
              <span
                >{{ timezone === 'UTC' ?
                  (element?.submissionDate | date : "dd/MM/yyyy - hh.mm a" : 'GMT') :
                  (element?.submissionDate)
                }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="startdue">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by symbol"
              class="align"
              style="padding-left: 35px;"
            >
              Start Date <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span>
            </mat-header-cell>
            <mat-cell class="frequency-cell align" *matCellDef="let element"
            style="padding-left: 35px;"
            >
              <span
              >{{ timezone === 'UTC' ?
                (element?.startDate | date : "dd/MM/yyyy - hh.mm a" : 'GMT') :
                (element?.startDate)
              }}
            </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="enddue">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by enddue"
              class="align"
            >
              End Date <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span>
            </mat-header-cell>
            <mat-cell class="frequency-cell align" *matCellDef="let element">
              <span
              >{{ timezone === 'UTC' ?
                (element?.endDate | date : "dd/MM/yyyy - hh.mm a" : 'GMT') :
                (element?.endDate)
              }}
            </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="taskcost">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by taskcost"
            >
              <ng-container *ngIf="!currentUser?.pointsEligible && currentUser?.allocated; else otherLabel">
                Task Number
              </ng-container>
              <ng-template #otherLabel>
                Order Cost
              </ng-template>
            </mat-header-cell>
            <mat-cell class="taskcost-cell" *matCellDef="let element">
              <span style="justify-content: center;padding-right: 15px;" *ngIf="!currentUser?.pointsEligible && currentUser?.allocated">{{ element?.totalTaskNumber }}</span>
              <span *ngIf="!currentUser?.pointsEligible && !currentUser?.allocated"
              [matTooltip]="getTaskCostTooltip(element, element?.taskcost)">
                {{ element.taskcost | currencyFormat }}
              </span>
              <span *ngIf="currentUser?.pointsEligible"
              [matTooltip]="getTaskCostTooltip(element, element?.taskPoint)">
                {{ element.taskPoint }} points
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="frequency">
            <mat-header-cell *matHeaderCellDef> Frequency </mat-header-cell>
            <mat-cell class="frequency-cell" *matCellDef="let element">
              <ng-container
                *ngIf="element.frequency === 0; else recurrentBlock"
              >
                <span>Specific Date</span>
              </ng-container>
              <ng-template #recurrentBlock>
                <ng-container *ngIf="element.frequency === 1; else periodBlock">
                  <span>Recurrent</span>
                </ng-container>
              </ng-template>
              <ng-template #periodBlock>
                <ng-container *ngIf="element.frequency === 2; else specificDayBlock">
                  <span> Period</span>
                </ng-container>
              </ng-template>
              <ng-template #specificDayBlock>
                <ng-container *ngIf="element.frequency === 3; else nullBlock">
                  <span>Specific Day</span>
                </ng-container>
              </ng-template>
              <ng-template #nullBlock></ng-template>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="repeatfrequency">
            <mat-header-cell *matHeaderCellDef>
              Repeat Frequency
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.frequency === 1; else nullBlock">
                <span
                  style="margin-left: 0"
                  >{{ element.repeatFrequency | titlecase }} ({{
                    element.noOfRepeats
                  }})</span
                >
              </ng-container>
              <ng-template #nullBlock>{{ element.noOfRepeats }}</ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ISTask">
            <mat-header-cell class="mat-head-cells" *matHeaderCellDef
            style="justify-content: left !important;">
              <span style="margin-left: 35px;">
                Feeds
                <img
                  style="margin-left: 4px; margin-top: -2px"
                  width="14px"
                  src="../../../assets/images/union-white.svg"
                  matTooltip="Automatic extraction of information of interest"
                  matTooltipClass="tooltips"
                />
              </span>
            </mat-header-cell>
            <mat-cell class="mat-head-cells" *matCellDef="let element"
             style="justify-content: left !important;">
              <ng-container *ngIf="element.isISTask; else nullBlock">
                <span *ngIf="element.isISTask" style="margin-left: 35px;">{{
                  "Yes"
                }}

                <!-- <img
                    (mouseover)="getIsTooltipText(element.mlTasks)"
                    style="margin-left: 4px; margin-top: -2px"
                    width="14px"
                    src="../../../assets/images/union.svg"
                    [matTooltip]="isServices"
                    matTooltipClass="tooltips" /> -->
              </span>
              </ng-container>
              <ng-template #nullBlock>
                <span style="margin-left: 35px;">{{ "No" }}</span>
              </ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="button">
            <mat-header-cell
              class="mat-head-cells"
              *matHeaderCellDef
              sortActionDescription="Sort by button"
              style="width: 520px !important;"
            >
              Status
            </mat-header-cell>
            <mat-cell class="status-cell" *matCellDef="let element"
            style="width: 520px !important;">
              <span *ngIf="!element?.outcomeCheck" fxLayoutGap="15px">
              <span
                class="badge rounded-pill task-canceled waiting text-center"
                *ngIf="element.yellowCount > 0"
                >{{ element.yellowCount }}</span
              >
              <span
                class="badge rounded-pill task-canceled cancelled text-center"
                *ngIf="element.redCount > 0"
              >
                {{ element.redCount }}</span
              >
              <span
                class="badge rounded-pill task-canceled success text-center"
                *ngIf="element.greenCount > 0"
              >
                {{ element.greenCount }}</span
              >
              <!-- <span
                class="badge rounded-pill task-canceled waiting text-center"
                *ngIf="element.delivering > 0"
              >
                {{ element.delivering }}</span
              > -->
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="preview">
            <mat-header-cell
              class="mat-head-cells"
              *matHeaderCellDef
              sortActionDescription="Sort by button"
              >Preview
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="preview-cell overlay"
            >
              <span
                (click)="OpenPopup(element);handleButtonClick($event)"
                [ngClass]="
                  element.redCount > 0 &&
                  element.greenCount < 1 &&
                  element.yellowCount === 0 &&
                  !element?.outcomeCheck
                    ? 'material-icons-outlined preview-disabled'
                    : 'material-icons-outlined map-active'
                "
              >
                map
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell
              class=""
              *matHeaderCellDef
              sortActionDescription="Sort by button"
            >
              Action
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element; let i = index"
            >
              <span
                *ngIf="element?.repeatFrequency !== 'Days'"
                class="retask-tooltip-trigger"
                [matTooltip]="getProjectRetaskTooltip(element)"
                [matTooltipDisabled]="!getProjectRetaskTooltip(element)"
              >
                <button
                  class="btn btn-gray retask-button sensor-retask-button project-retask-button"
                  (click)="getRetask(element);handleButtonClick($event)"
                  [disabled]="!canRetaskProject(element) || noTaskCreatePermission"
                  [class.disabledButton]="!canRetaskProject(element) || noTaskCreatePermission"
                >
                  <mat-icon class="retask-button-icon" aria-hidden="true">autorenew</mat-icon>
                  Re-Task
                </button>
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rating">
            <mat-header-cell
              class="mat-head-cells"
              *matHeaderCellDef
              style="margin-left: -20px;"
            >
            </mat-header-cell>
            <mat-cell
              class="preview-cell"
              *matCellDef="let element; let i = index"
              style="margin-left: -20px;"
            >
            <span *ngIf="element.taskCompleted" (click)="rateTask(element);handleButtonClick($event)"
              class="material-icons-outlined map-active" [matTooltip]="!element?.feedback ? 'Rate your task' : ''"
              [ngClass]="{'feedback-disable': element?.feedback}">
              reviews
            </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expandedDetail" class="expanded">
            <mat-cell
              *matCellDef="let detail; let i = index"
              style="display: block"
            >
              <!-- Days tabbed view -->
              <ng-container *ngIf="detail.repeatFrequency === 'Days' && !detail?.outcomeCheck">
                <mat-tab-group
                  class="days-week-tab-group"
                  [selectedIndex]="activeDaysWeekIndex[detail.id] || 0"
                  (selectedIndexChange)="onDaysWeekTabChange(detail, $event)">
                  <mat-tab *ngFor="let weekGroup of detail._groupedDaysRequests">

                    <ng-template mat-tab-label>
                      {{ weekGroup.weekLabel }}
                    </ng-template>

                    <!-- Day chips -->
                    <div class="day-chips-row">
                      <div
                        *ngFor="let group of weekGroup.weekGroups"
                        class="day-chip"
                        [class.day-chip--active]="activeDaysGroupKey[detail.id] === group.groupKey"
                        (click)="selectDayChip(detail, group.groupKey); $event.stopPropagation()">
                        <span class="day-chip-name">{{ group.week_day_short }}</span>
                        <span class="day-chip-date">{{ group.day_start_date | date:(taskSpansMultipleYears(detail) ? 'd MMM yyyy' : 'd MMM'):'GMT' }}</span>
                        <span *ngIf="group.greenCount > 0" class="badge rounded-pill task-canceled success text-center">{{ group.greenCount }}</span>
                        <span *ngIf="group.yellowCount > 0" class="badge rounded-pill task-canceled waiting text-center">{{ group.yellowCount }}</span>
                        <span *ngIf="group.redCount > 0" class="badge rounded-pill task-canceled cancelled text-center">{{ group.redCount }}</span>
                      </div>
                    </div>

                    <!-- Active day content -->
                    <ng-container *ngIf="getActiveGroup(detail, weekGroup) as activeGroup">
                      <div class="day-subtask-label">
                        <span class="day-subtask-title">Task:</span>
                        <span class="day-subtask-name">{{ getSubTaskName(activeGroup) }}</span>
                      </div>

                      <ng-container [ngTemplateOutlet]="sensorTableTemplate"
                                    [ngTemplateOutletContext]="{ sensors: activeGroup.sensors }">
                      </ng-container>

                      <div class="footer-style">
                        <div class="text-style"></div>
                        <div class="inner-table-footer">
                          <span *ngIf="detail?.feasibilityTask">
                            <button (click)="cancelOpportunities(detail)" class="btn btn-gray"
                              [disabled]="selectedTasks?.length === 0 || cancelFeasibility">
                              <span *ngIf="selectedTasks.length <= 1">Cancel Opportunity</span>
                              <span *ngIf="selectedTasks.length > 1">Cancel Opportunities</span>
                            </button>
                          </span>
                          <span *ngIf="detail.status !== 'canceled'">
                            <button (click)="cancelTask(detail, i, 'sensor')" class="btn btn-gray"
                              [disabled]="selectedTasks?.length === 0 || detail?.taskStrategy === 'Task From Collection' || !this.currentUser?.user_enabled || (this.rule === 'rule-3' && this.iscueing) || ((this.tipAndCueBasedOn === 'Feeds' || this.tipAndCueBasedOn === 'Observation') && this.iscueing) || cancelWeatherexOrdered">
                              <span *ngIf="selectedTasks.length <= 1">Cancel Sensor</span>
                              <span *ngIf="selectedTasks.length > 1">Cancel Sensors</span>
                            </button>
                          </span>
                          <button [disabled]="selectedSensors.length === 0 || detail.orderStatus || detail.greenCount === 0 || detail?.feasibilityTask || orderPending || detail?.taskStrategy === 'Task From Collection' || (currentUser?.permission_based && !currentUser?.permissions.includes(3)) || !this.currentUser?.user_enabled"
                            (click)="addToCart(detail,'cart')" class="btn btn-gray">Add to Cart</button>
                          <button (click)="checkout(detail, i)"
                            [ngClass]="(selectedSensors.length === 0 || detail.orderStatus || detail.completed === 0 || orderPending || detail?.taskStrategy === 'Task From Collection' || (currentUser?.permission_based && !currentUser?.permissions.includes(3)) || !this.currentUser?.user_enabled || selectedTasks.length === 0) ? 'btn btn-gray' : 'btn btn-black'"
                            [disabled]="selectedSensors.length === 0 || detail.orderStatus || detail.greenCount === 0 || orderPending || detail?.taskStrategy === 'Task From Collection' || (currentUser?.permission_based && !currentUser?.permissions.includes(3)) || !this.currentUser?.user_enabled || selectedTasks.length === 0">
                            Proceed to Pay
                          </button>
                        </div>
                      </div>
                    </ng-container>

                  </mat-tab>
                </mat-tab-group>
              </ng-container>

              <ng-template #sensorTableTemplate let-sensors="sensors">
              <table
                mat-table
                [dataSource]="sensors"
                class="mat-elevation-z8 non-sticky-header"
              >
                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <ng-container matColumnDef="check">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    [ngClass]="{ 'feed-checkbox-cell': shouldShowSensorNameFeedLayout(detail, element) }"
                  >
                    <mat-checkbox
                      class="example-margin"
                      [checked]="element.checked"
                      color="primary"
                      (change)="getTaskCost($event.checked, detail, element.requestIndex)"
                      [disabled]="
                        !element['status'] ||
                        element['status'] === 'canceled' ||
                        element['status'] === 'rejected' ||
                        element['status'] === 'failed' ||
                        element['status'] === 'cancel requested' ||
                        element['status'] === 'completed' ||
                        element['status'] === 'archived' ||
                        element['status'] === 'restored' ||
                        element['status'] === 'error' ||
                        element['status'] === 'approval rejected' ||
                        element['status'] === 'Unavailable'
                      "
                    >
                      <span
                        *ngIf="element.checked"
                        style="color: #026fc2; font-weight: bold"
                      >
                      </span>
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="sensorname">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    style="text-align: left"
                  >
                    Sensor Name
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="text-align: left"
                    [ngClass]="{ 'custom-name-display' : shouldShowSensorNameFeedLayout(detail, element) }"
                  >
                    <span [ngClass]="{'cell-content': hasValueAddedOptionKeys(element)}" [ngStyle]="detail?.observation?.[0]?.ais_observation && element.tnqSensorType !== 'Cueing' && !element?.feedData ? {'position': 'relative', 'top': '27px'} : {}">
                      {{ (currentUser?.obfuscated && element.obfuscateName) ? element.obfuscateName : element.name }} {{ element.sensor }}
                      <span style="margin-left: 2px;" *ngIf="element?.tnqSensorType">  ({{ element.tnqSensorType }}) </span>
                      <img
                        style="margin-left: 4px; margin-top: -4px; margin-right: 4px"
                        width="14px"
                        [src]="tooltipImagePath"
                        [matTooltipDisabled]="tooltipDisabled"
                        [matTooltip]="this.detailsText"
                        matTooltipClass="tooltips"
                        (mouseover)="selections(element)"
                        (mouseout)="onMouseOut()"
                        [ngStyle]="{'margin-top': hasValueAddedOptionKeys(element) ? '0px' : '-4px'}"
                      />
                      <mat-icon
                        class="material-icons-outlined map-active"
                        *ngIf="element?.bandTooltip"
                        [matTooltip]="element.bandTooltip"
                        [matTooltipClass]="'custom-tooltip'"
                        matTooltipPosition="below"
                        style="cursor: default; font-size: 17px; width: 17px; height: 17px; margin-left: 4px; margin-top: -4px;margin-right: 4px; vertical-align: middle;"
                        [ngStyle]="{'margin-top': hasValueAddedOptionKeys(element) ? '0px' : '-4px'}"
                      >
                        graphic_eq
                      </mat-icon>
                      <mat-icon
                        class="material-icons-outlined map-active"
                        *ngIf="element?.variablesTooltip"
                        [matTooltip]="element.variablesTooltip"
                        [matTooltipClass]="'custom-tooltip'"
                        matTooltipPosition="below"
                        style="cursor: default; font-size: 17px; width: 17px; height: 17px; margin-left: 4px; margin-top: -4px; margin-right: 4px; vertical-align: middle;"
                        [ngStyle]="{'margin-top': hasValueAddedOptionKeys(element) ? '0px' : '-4px'}"
                      >
                        graphic_eq
                      </mat-icon>
                      <mat-icon
                        class="custom-dem-icon emails"
                        *ngIf="hasValueAddedOptionKeys(element)"
                        [appCustomTooltip]="tooltipTemplate"
                        [appCustomTooltipContext]="element"
                      >
                      3d_rotation
                      </mat-icon>
                      <mat-icon
                      class="custom-dem-icon"
                      *ngIf="element?.isAudio"
                      matTooltip="The task includes audio files."
                    >
                    volume_up
                  </mat-icon>
                  <img *ngIf="element.name == 'Multi'"
                  style="margin-left: 4px; margin-top: -4px"
                  width="14px"
                  src="../../../assets/images/signalcost.png"
                  [appCustomTooltip]="tooltipTemplate1"
                  [appCustomTooltipContext]="element"
                />
                    </span>
                    <div *ngIf="detail?.taskStrategy !== 'Feed Based' && element?.feedData?.length > 0" class="feed-sub-list">
                      <div *ngFor="let feed of element.feedData" class="feed-sub-row">
                        <span class="feed-sub-label">{{ feed.feedName ? feed.feedName : ('Observation name: ' + feed.name) }}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>
                
                <ng-template #tooltipTemplate let-element>
                  <div class="custom-tooltip">
                    <mat-table [dataSource]="getDataRows(element)" class="custom-tooltip-table">
                      <!-- Columns definition -->
                      <ng-container matColumnDef="actionProvider">
                        <mat-header-cell *matHeaderCellDef class="action-provider-column dark-bg"> Value Added Data Products </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="action-provider-column"> <span>{{ item.actionProvider }}</span>

                        <img *ngIf="item.english_word"
                         style="margin-left: 4px; margin-top: -1px"
                         width="14px"
                         [src]="tooltipImagePath"
                         [matTooltip]="item.english_word"
          /> </mat-cell>
                      </ng-container>
                      
                      <ng-container matColumnDef="sensorResolution">
                        <mat-header-cell *matHeaderCellDef class="sensor-resolution-column center-align dark-bg"> Resolution </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="sensor-resolution-column center-align">
                          {{ item?.valueAddedDataProduct === 'indices' ?  element?.originalResolution : item.providerResolution }} 
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="deliveryTime">
                        <mat-header-cell *matHeaderCellDef class="delivery-time-column center-align dark-bg"> Delivery Time </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="delivery-time-column center-align">
                          {{ item?.valueAddedDataProduct === 'indices' ? indicesDeliveryTime : item.deliveryTime + 'hrs' }} 
                        </mat-cell>
                      </ng-container>
                      
                      <ng-container matColumnDef="cost">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Cost </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> 
                          {{ item.totalareacost | currencyFormat }}
                        </mat-cell>
                      </ng-container>
                      
                      <ng-container matColumnDef="point">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Points </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> {{ item?.totalareapoints }} points </mat-cell>
                      </ng-container>
                      
                      <!-- Header and row definitions -->
                      <mat-header-row *matHeaderRowDef="customTooltipColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: customTooltipColumns;"></mat-row>
                    </mat-table>
                  </div>
                </ng-template>

                <ng-template #tooltipTemplate1 let-element>
                  <div class="custom-tooltip">
                    <mat-table [dataSource]="element.signalOfInterest" class="custom-tooltip-table">
                      <!-- Columns definition -->
                      <ng-container matColumnDef="Signal">
                        <mat-header-cell *matHeaderCellDef class="action-provider-column dark-bg"> Signals </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="action-provider-column"> {{ item?.value }} </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Collection Duration">
                        <mat-header-cell *matHeaderCellDef class="sensor-resolution-column center-align dark-bg"> Collection Duration </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="sensor-resolution-column center-align">
                          {{ item.collectionDuration }}sec 
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Task Number">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Task Number </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> {{ item?.taskNumber ? item.taskNumber : 'N/A' }} </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Cost">
                        <mat-header-cell *matHeaderCellDef class="delivery-time-column center-align dark-bg"> Cost </mat-header-cell>
                        <mat-cell *matCellDef="let item" class="delivery-time-column center-align">
                          {{ item?.cost != null ? (item.cost | currencyFormat) : 'N/A' }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Audio">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Audio </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> 
                          {{ item.isAudio ? 'Yes' : 'N/A'}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Audio Cost">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Audio Cost </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> {{ item.isAudio && item?.audioCost ? (item.audioCost | currencyFormat) : 'N/A' }} </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Point">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Points </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> {{ item?.point ? item?.point+' points' : 'N/A' }} </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="Audio Point">
                        <mat-header-cell class="cost-align cost-column center-align dark-bg" *matHeaderCellDef> Audio Points </mat-header-cell>
                        <mat-cell class="cost-align cost-column center-align" *matCellDef="let item"> {{ item.isAudio && item?.audioPoint ? item?.audioPoint +' points' : 'N/A' }}  </mat-cell>
                      </ng-container>



                      <!-- Header and row definitions -->
                      <mat-header-row *matHeaderRowDef="getSignalTooltipColumns(element)"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: getSignalTooltipColumns(element);"></mat-row>
                    </mat-table>
                  </div>
                </ng-template>

                <ng-container matColumnDef="taskid">
                  <th mat-header-cell *matHeaderCellDef>Sensor ID</th>
                  <td class="frequency-cell" mat-cell *matCellDef="let element"
                    [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0 }">
                    <span
                      [matTooltip]="element.uuid"
                      
                    >
                      {{ element.uuid }}</span
                    >
                  </td>
                </ng-container>

                <ng-container matColumnDef="resolution">
                  <th mat-header-cell *matHeaderCellDef>{{resolutionColumn}}</th>
                  <td mat-cell *matCellDef="let element"
                    [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0 }">
                      <!-- RF Sensor (BRO) -->
                  <span *ngIf="element?.sensor === 'RF' && element?.name === 'BRO'">
      {{ element?.rf_services?.value }}
        <img
        *ngIf="element?.rf_services?.mode_value"
        style="margin-left: 5px; margin-top: -4px"
        width="14px"
        [src]="tooltipImagePath"
        [matTooltip]="element?.rf_services?.mode_value"
      />
    </span>
                    <span
                        *ngIf="element?.operatorKey != OPERATORS.SPIRE && element?.operatorKey != OPERATORS.CLYDE && !(element?.sensor === 'RF' && element?.name === 'BRO')"
                      >
                        {{ element?.resolution?.value || element?.resolution }}
                        <img
                          *ngIf="element?.resolutionTooltip"
                          style="margin-left: 5px; margin-top: -4px"
                          width="14px"
                          [src]="tooltipImagePath"
                          [matTooltip]="element.resolutionTooltip"
                        />
                        <img
                        *ngIf="element?.collectionMode && element?.operatorKey === OPERATORS.BLACKSKY"
                        style="margin-left: 5px; margin-top: -2px"
                        width="14px"
                        [src]="tooltipImagePath"
                        [matTooltip]="element?.collectionMode[0]?.captureMode"
                      />
                      </span>
                      <span
                        *ngIf="element?.operatorKey === OPERATORS.SPIRE || 
                        element?.operatorKey === OPERATORS.CLYDE ||
                        element?.operatorKey === OPERATORS.LBAND"
                        style="text-align: center"
                      >
                        &lt; not applicable &gt;
                      </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="unit">
                  <th mat-header-cell *matHeaderCellDef>Tasked Area (sqkm)</th>
                  <td mat-cell *matCellDef="let element"
                  [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }">
                  {{ (element?.operatorKey === OPERATORS.UMBRA && element?.sensortype === 'ScanSAR' && detail?.scanArea > 0) ? detail.scanArea : (element.isPoint? element.minimumArea :(!element?.isPoint && element.isCalculatedAreaSmaller ? formatTaskArea(element.areacalc,element.minimumArea)  :element.areacalc)) }}</td>
                </ng-container>

                <ng-container matColumnDef="tasking">
                  <th mat-header-cell *matHeaderCellDef>Tasking Tier</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="text-transform: capitalize"
                    [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }"
                  >
                    <span style="text-align: center">{{
                      element?.latency?.name
                        ? element?.latency.name
                        : element?.latency
                    }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="cloudcover">
                  <th mat-header-cell *matHeaderCellDef>Cloud Cover</th>
                  <td mat-cell *matCellDef="let element" 
                  [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }">
                     <span
                        *ngIf="element?.operatorKey != OPERATORS.SPIRE && element?.operatorKey != OPERATORS.CLYDE"
                      >
                        {{ element.cloudcover }}
                      </span>
                      <span
                        *ngIf="element?.operatorKey === OPERATORS.SPIRE ||
                        element?.operatorKey === OPERATORS.CLYDE || 
                        element?.operatorKey === OPERATORS.LBAND"
                        style="text-align: center"
                      >
                        &lt; not applicable &gt;
                      </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="firstcapture">
                  <th mat-header-cell *matHeaderCellDef>First Capture <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></th>
                  <td mat-cell *matCellDef="let element"
                  [ngClass]="{ 'custom-feed-display' : shouldShowCustomFeedDisplay(element) }">
                    <span *ngIf="element.status != 'rejected'">
                      <span
                        *ngIf="
                          element?.firstCapture &&
                          element?.operatorKey != OPERATORS.AT21 &&
                          element?.operatorKey != OPERATORS.KOMPSAT &&
                          element?.operatorKey !== OPERATORS.WYVERN &&
                          element?.operatorKey !== OPERATORS.SDS &&
                          element?.operatorKey !== OPERATORS.ORBVIEW &&
                          element?.operatorKey !== OPERATORS.CONSTELLR
                        "
                        style="text-align: center"
                        [matTooltip]="element?.feasibility ? 'The first opportunity from multiple opportunities within the time of interest (TOI) or the approved/ordered opportunity.' : ''"
                        >{{ timezone === 'UTC' ?
                          (element?.firstCaptureTime
                            | date : "dd/MM/yyyy - hh.mm a" : 'GMT') : 
                            (element?.firstCaptureTime)
                      }}
                      </span>
                      <span *ngIf="!element?.firstCapture && element?.supportFeasibility === false &&
                       (element?.status == 'approved' || element?.status == 'ordered') &&
                       (element?.operatorKey !== OPERATORS.AT21 && element?.operatorKey !== OPERATORS.KOMPSAT && element?.operatorKey !== OPERATORS.WYVERN && element?.operatorKey !== OPERATORS.SDS && element?.operatorKey !== OPERATORS.ORBVIEW && element?.operatorKey !== OPERATORS.CONSTELLR)" style="text-align: center">
                        &lt; Unavailable &gt;
                      </span>
                      <span
                        *ngIf="
                          !element?.firstCapture &&
                          element?.operatorKey != OPERATORS.AT21 &&
                          element?.operatorKey != OPERATORS.KOMPSAT && element?.operatorKey != OPERATORS.WYVERN && element?.operatorKey !== OPERATORS.SDS && element?.operatorKey !== OPERATORS.ORBVIEW && element?.operatorKey !== OPERATORS.CONSTELLR &&
                          element.status != 'canceled' &&
                          element.status != 'failed' &&
                          !(element?.supportFeasibility === false && (element?.status == 'approved' || element?.status == 'ordered'))
                        "
                        style="text-align: center"
                      >
                        &lt; pending &gt;
                      </span>
                      <span
                        *ngIf="
                          !element?.firstCapture &&
                          (element?.operatorKey === OPERATORS.AT21 ||
                            element?.operatorKey === OPERATORS.KOMPSAT || element?.operatorKey === OPERATORS.WYVERN || element?.operatorKey === OPERATORS.SDS || element?.operatorKey === OPERATORS.ORBVIEW || element?.operatorKey === OPERATORS.CONSTELLR) 
                        "
                        style="text-align: center"
                      >
                        &lt; Unavailable &gt;
                      </span>
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="lastcapture">
                  <th mat-header-cell *matHeaderCellDef>Last Capture <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></th>
                  <td mat-cell *matCellDef="let element" 
                  [ngClass]="{ 'custom-feed-display' : shouldShowCustomFeedDisplay(element) }">

                    <span *ngIf="element.status != 'rejected'">
                      <span
                        *ngIf="
                          element?.firstCapture &&
                          element?.operatorKey != OPERATORS.AT21 &&
                          element?.operatorKey != OPERATORS.KOMPSAT &&
                          element?.operatorKey !== OPERATORS.WYVERN &&
                          element?.operatorKey !== OPERATORS.SDS &&
                          element?.operatorKey !== OPERATORS.ORBVIEW &&
                          element?.operatorKey !== OPERATORS.CONSTELLR
                        "
                        style="text-align: center"
                        [matTooltip]="element?.feasibility ? 'The last opportunity from multiple opportunities within the time of interest (TOI) or the approved/ordered opportunity.' : ''"
                        >{{ timezone === 'UTC' ? ((element?.lastCapture ? element?.lastCaptureTime : element?.firstCaptureTime) 
                      | date : "dd/MM/yyyy - hh.mm a" : 'GMT') :
                       (element?.lastCapture ? element?.lastCaptureTime : element?.firstCaptureTime)
                      }}
                    </span>
                      <span *ngIf="!element?.lastCapture && element?.supportFeasibility === false &&
                      (element?.status == 'approved' || element?.status == 'ordered') &&
                      (element?.operatorKey !== OPERATORS.AT21 && element?.operatorKey !== OPERATORS.KOMPSAT && element?.operatorKey !== OPERATORS.WYVERN && element?.operatorKey !== OPERATORS.SDS && element?.operatorKey !== OPERATORS.ORBVIEW && element?.operatorKey !== OPERATORS.CONSTELLR)" style="text-align: center">
                        &lt; Unavailable &gt;
                      </span>
                      <span
                        *ngIf="
                          !element?.firstCapture &&
                          element?.operatorKey != OPERATORS.AT21 &&
                          element?.operatorKey != OPERATORS.KOMPSAT  && element?.operatorKey != OPERATORS.WYVERN && element?.operatorKey != OPERATORS.SDS && element?.operatorKey != OPERATORS.ORBVIEW && element?.operatorKey !== OPERATORS.CONSTELLR &&
                          element.status != 'canceled' &&
                          element.status != 'failed' &&
                          !(element?.supportFeasibility === false && (element?.status == 'approved' || element?.status == 'ordered'))
                        "
                        style="text-align: center"
                      >
                        &lt; pending &gt;
                      </span>
                      <span
                        *ngIf="
                          !element?.firstCapture &&
                          (element?.operatorKey === OPERATORS.AT21 ||
                            element?.operatorKey === OPERATORS.KOMPSAT || element?.operatorKey === OPERATORS.WYVERN || element?.operatorKey === OPERATORS.SDS || element?.operatorKey === OPERATORS.ORBVIEW || element?.operatorKey === OPERATORS.CONSTELLR)
                        "
                        style="text-align: center"
                      >
                        &lt; Unavailable &gt;
                      </span>
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="sensorcost">
                  <th mat-header-cell *matHeaderCellDef>
                    <ng-container *ngIf="!currentUser?.pointsEligible && currentUser.allocated; else otherLabel">
                      Sensor Task Number
                    </ng-container>
                    <ng-template #otherLabel>
                      Sensor Cost
                    </ng-template>
                  </th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{ 'custom-name-display' : shouldShowSensorCostFeedLayout(detail, element) }">
                    <div class="sensorcost-primary" *ngIf="!currentUser?.pointsEligible && !currentUser.allocated" [ngStyle]="{'margin-bottom': element?.feedData?.length > 0 && (detail?.observation?.[0]?.ais_observation || detail?.observation?.[0]?.rf_observation) ? '35px' : '0'}">
                      <span>{{ element.cost | currencyFormat }}</span>
                      <div *ngIf="element?.feedData?.length > 0 && !(detail?.observation?.[0]?.ais_observation || detail?.observation?.[0]?.rf_observation)"
                        class="feed-value-list">
                        <div *ngFor="let feed of element.feedData" class="feed-value-row">
                          <span class="feed-cost-padding">{{ ((feed?.price || 0) + (feed?.weather_ex_cost && feed?.weather_ex_cost > 0 ? feed?.weather_ex_cost : 0)) === 0 ? 'US$ 0' : ((feed?.price || 0) + (feed?.weather_ex_cost && feed?.weather_ex_cost > 0 ? feed?.weather_ex_cost : 0)) > 0 ? ((((feed?.price || 0) + (feed?.weather_ex_cost && feed?.weather_ex_cost > 0 ? feed?.weather_ex_cost : 0)) | currencyFormat)) : '' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sensorcost-primary" *ngIf="currentUser?.pointsEligible">
                      <span>{{ element?.point }} points</span>
                      <div *ngIf="element?.feedData?.length > 0 " class="feed-value-list">
                        <div *ngFor="let feed of element.feedData" class="feed-value-row">
                          <span class="feed-cost-padding">{{ ((feed?.points || 0) + (feed?.weather_ex_point && feed?.weather_ex_point > 0 ? feed?.weather_ex_point : 0)) }} points</span>
                        </div>
                      </div>
                    </div>
                    <div class="sensorcost-primary" *ngIf="!currentUser?.pointsEligible && currentUser.allocated">
                      <span>{{ element.taskNumber }}</span>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="oprtyTask">
                  <th *matHeaderCellDef mat-header-cell></th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="padding-left: 0px !important; margin-left: -6px"
                    [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }"
                  >
                    <span
                      *ngIf="
                        element?.feasibility && element.status === 'approved'
                      "
                      (click)="OpenFeasibilty(element, element.requestIndex, detail)"
                    >
                      <!-- <mat-icon class="material-icons-outlined settings-active" style="cursor: pointer" matTooltip="Capture Opportunities">
                        query_stats
                      </mat-icon> -->
                     <span
                      [matTooltip]="!detail.hasExpired
                        ? 'Capture Opportunities'
                        : 'The time of interest (TOI) has expired, and no opportunities exist. Please re-task.'"
                      matTooltipShowDelay="100"
                       style="display: inline-flex; align-items: center;"
                    >
                      <img
                        width="40px"
                        [src]="orbitImage"
                        width="40"
                        height="40"
                        style="vertical-align: middle;"
                        [style.opacity]="detail.hasExpired ? 0.4 : 1"
                        [style.cursor]="detail.hasExpired ? 'not-allowed' : 'pointer'"
                      />
                    </span>
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="feeds">
                <th *matHeaderCellDef mat-header-cell></th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }"
                >
                   <ng-container *ngIf="feedsAvailabilityMap[element.uuid]">
                    <span 
                     [matTooltip]="'Select the feeds'"
                      matTooltipShowDelay="100"
                       style="display: inline-flex; align-items: center;"
                      (click)="SelectFeeds(detail, element); $event.stopPropagation()"
                      [ngClass]="'material-icons-outlined map-active'"
                    >
                      <img
                        [src]="
                            element.status == 'Unavailable' || element.status == 'awaiting' || element.status == 'failed' || element.status == 'rejected' || element.status == 'canceled'
                              ? '../../../assets/images/sat-earth-disabled.png'
                              : '../../../assets/images/sat-earth.png'
                          "
                          alt="Select Feeds"
                          [style.width.px]="getImageSize(element.status)"
                          [style.height.px]="getImageSize(element.status)"
                          style="display: inline-block;"
                        />
                      </span>
                    </ng-container>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0 }">
                    <span
                      class="retask-tooltip-trigger"
                      [matTooltip]="getTaskRetaskTooltip(detail, element)"
                      [matTooltipDisabled]="!getTaskRetaskTooltip(detail, element)"
                    >
                      <button
                        class="btn btn-gray retask-button sensor-retask-button"
                        (click)="retaskSensor(detail, element); handleButtonClick($event)"
                        [disabled]="!canRetaskSensor(detail, element) || noTaskCreatePermission"
                        [class.disabledButton]="!canRetaskSensor(detail, element) || noTaskCreatePermission"
                      >
                        <mat-icon class="retask-button-icon" aria-hidden="true">autorenew</mat-icon>
                        Re-Task
                      </button>
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef style="padding-right: 10px;">Status</th>
                  <td class="status-color" [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }"  mat-cell *matCellDef="let element">
                    <div class="status-container">
                      <div >
                        <span style="text-align: center">
                          <button
                            class="task-btn approved btn"
                            *ngIf="
                              element['orderStatus'] &&
                              element.status != 'rejected' &&
                              element.status != 'canceled' &&
                              element.status != 'failed' &&
                              element['status'] !== 'completed' &&
                              element['status'] !== 'delivering' &&
                              element['status'] !== 'cancel requested' &&
                              element.status != 'collected' &&
                              element['status'] !== 'pending approval'
                            "
                          >
                            {{ element.orderStatus }}
                          </button>
                          <button
                            class="task-btn approved btn"
                            *ngIf="
                              !element['orderStatus'] &&
                              (element['status'] === 'received' ||
                                element['status'] === 'approved' ||
                                element['status'] === 'Ordered' ||
                                element['status'] === 'submitted' ||
                                element['status'] === 'active' ||
                                element.status === 'approved' ||
                                element['status'] === 'accepted')
                            "
                          >
                            {{ element.status }}
                          </button>
                          <button
                            class="task-btn approved btn"
                            *ngIf="element['status'] === 'completed'"
                          >
                            {{ element.status }}
                          </button>

                          <button
                            class="task-btn cancel btn"
                            *ngIf="
                              element.status === 'rejected' ||
                              element.status === 'canceled' ||
                              element.status === 'failed' ||
                              element.status === 'error' || 
                              element.status === 'approval rejected' ||
                              element.status === 'Unavailable'
                            "
                          >
                            {{ element.status }}
                          </button>
                          <button
                            class="task-btn awaiting btn"
                            *ngIf="
                              !element['orderStatus'] &&
                              element.status === 'awaiting'
                            "
                          >
                            Awaiting
                          </button>
                          <button
                            class="task-btn awaiting btn"
                            *ngIf="
                              (element['orderStatus'] &&
                              element.status === 'delivering') || (!element['orderStatus'] && element.status === 'pending')
                              || (element['orderStatus'] && element.status === 'cancel requested') 
                              || (element.status === 'collected')
                              || element.status === 'pending approval'">
                            {{ element.status }}
                          </button>
                        </span>
                        <div *ngIf="detail?.taskStrategy !== 'Feed Based' && element?.feedData?.length > 0" class="feed-status-list">
                          <div *ngFor="let feed of element.feedData" class="feed-status-row">
                            <span
                              *ngIf="hasFeedStatus(getFeedItemStatus(feed))"
                              class="feed-status-badge"
                              [style.background-color]="getFeedStatusColor(getFeedItemStatus(feed))"
                            >
                              {{ getFeedStatusLabel(getFeedItemStatus(feed)) }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <img
                        *ngIf="element?.operatorKey === OPERATORS.SATELLOGIC && (element?.status?.toLowerCase?.() === 'approved' || element?.['status']?.toLowerCase?.() === 'approved')"
                        style="margin-left: 4px; margin-top: 4px; cursor: pointer;"
                        alt="tooltip"
                        width="14px"
                        [src]="tooltipImagePath"
                        matTooltip="The operator may change the capture opportunities for this approved task, which will impact when collection happens within the time of interest (TOI). It might cause a task to be either rejected or fail after ordering."
                        matTooltipShowDelay="100"
                      />
                      <img *ngIf="element.status === 'collected'"
                      style="margin-left: 4px; margin-top: 4px"
                      alt="tooltip"
                      width="14px"
                      [src]="tooltipImagePath"
                      matTooltip='Indicates that a satellite has made a capture; however, the data is still going through processing steps and may fail. In which case, depending on the time of interest (TOI) left, re-attempts may be made. If not successful, the task will fail.'
                    />
                      <img
                        *ngIf="element?.status?.toLowerCase?.() === 'failed' && detail?.taskStrategy === 'TLE Based Tasking'"
                        style="margin-left: 4px; margin-top: 4px"
                        alt="tooltip"
                        width="14px"
                        [src]="tooltipImagePath"
                        matTooltip="The satellite with the closest pass did not have the capacity to collect at the time specified."
                        matTooltipShowDelay="100"
                      />

                      <img *ngIf="element?.retaskingTooltip?.length > 0"
                      style="margin-left: 4px; margin-top: 4px"
                      width="14px"
                      [src]="tooltipImagePath"
                      [matTooltip]="this.detailsText"
                      (mouseover)="formatTooltip(element?.retaskingTooltip)"
                      (mouseout)="onMouseOut()"
                      [matTooltipDisabled]="tooltipDisabled"
                    />
                      <mat-icon 
                      class="material-icons-outlined map-active" *ngIf="currentUser?.permission_based && 
                      currentUser?.permissions.includes(2) && element.status === 'pending approval' && this.currentUser?.user_enabled"
                      style="cursor: pointer;margin-bottom: -12px;padding-left: 4px;"
                      matTooltip="Click here to approve or reject the sensor" (click)="clickTaskActions(element,detail);">
                      task_alt
                      </mat-icon>

                      <mat-icon 
                      class="material-icons-outlined map-active" *ngIf="element.status === 'awaiting' && 
                      element?.operatorKey === OPERATORS.PIXXEL && element?.feasibilityError"
                      style="cursor: pointer;margin-bottom: -12px;padding-left: 4px;"
                      matTooltip="Click here to check the status of the sensor" (click)="checkTaskStatus(element,detail);">
                      info
                      </mat-icon>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="downloaded">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" class="downloaded-cell custom-feed-display">
                    <img
                      *ngIf="element?.downloaded"
                      style="margin-left: 6px; margin-top: -2px"
                      width="23px"
                      [src]="downloadedImage"
                      matTooltip="This sensor data has been downloaded"
                      matTooltipShowDelay="100"
                    />
                  </td>
                </ng-container>

                  <ng-container *ngIf="currentUser?.permission_based" matColumnDef="previousActor">
                  <th mat-header-cell *matHeaderCellDef>Previous Actor</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="text-transform: capitalize"
                    [ngClass]="{ 'custom-feed-display' : element?.feedData?.length > 0  }"
                  >
                    <span style="text-align: center">
                      {{element?.cancelerDetails ? element.cancelerDetails.firstName : element?.ordererDetails ? element.ordererDetails.firstName :
                      element?.approverDetails ? element.approverDetails.firstName : element.rejecterDetails ? element.rejecterDetails?.firstName 
                      : element.taskerDetails?.firstName}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="questionName">
               <th mat-header-cell *matHeaderCellDef> Question Name </th>
               <td mat-cell *matCellDef="let row">
                {{ row?.questionName }}
                 </td>
                </ng-container>

                <ng-container matColumnDef="questionId">
                <th mat-header-cell *matHeaderCellDef>Question ID</th>
                <td mat-cell *matCellDef="let row">
                 {{ row?.questionId }}
                </td>
                </ng-container>

                <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef>Cost</th>
                <td mat-cell *matCellDef="let element">
                 {{ element?.cost | currencyFormat }}
                </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="getInnerNameDisplayColumns(detail, sensors)"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: getInnerNameDisplayColumns(detail, sensors)"
                ></tr>
              
              </table>
              </ng-template>

              <ng-container *ngIf="!detail?.outcomeCheck && detail?.repeatFrequency !== 'Days'"
                [ngTemplateOutlet]="sensorTableTemplate"
                [ngTemplateOutletContext]="{ sensors: detail.request }">
              </ng-container>

              <table mat-table [dataSource]="detail.request" class="mat-elevation-z8 non-sticky-header" *ngIf="detail?.outcomeCheck">

                <ng-container matColumnDef="check">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                  </td>
                </ng-container>

                <ng-container matColumnDef="sensorname">
                  <th mat-header-cell *matHeaderCellDef style="text-align: left;">Sensor Name</th>
                  <td mat-cell *matCellDef="let element" style="text-align: left;">
                  </td>
                </ng-container>

                <ng-container matColumnDef="taskid">
                  <th mat-header-cell *matHeaderCellDef>Sensor ID</th>
                  <td class="frequency-cell" mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="resolution">
                  <th mat-header-cell *matHeaderCellDef>{{resolutionColumn}}</th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="unit">
                  <th mat-header-cell *matHeaderCellDef>Tasked Area (sqkm)</th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="tasking">
                  <th mat-header-cell *matHeaderCellDef>Tasking Tier</th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;">
                    <span *ngIf="detail?.outcomeCheck && !detail?.outcomeRejected">Awaiting for operator approvals.</span>
                     <span *ngIf="detail?.taskStrategy === 'TLE Based Tasking' && detail?.outcomeRejected">
                      The satellite with the closest pass did not have the capacity to collect at the time specified.
                    </span>
                    <span *ngIf="detail?.outcomeCheck && detail?.outcomeRejected && !detail?.insufficientBalance && detail?.taskStrategy !== 'TLE Based Tasking'">
                      There are no operators to deliver to your requirements. 
                      <span *ngIf="detail?.taskStrategy != 'Task From Collection' && detail?.taskStrategy !== 'TLE Based Tasking'">Please increase your budget,<br/>
                      change the resolution, increase your data request time, or do all the above to improve the chance of approval.
                     </span>
                     <span *ngIf="detail?.taskStrategy === 'Task From Collection'">Please change the resolution,<br/>
                      increase your data request time, or do all the above to improve the chance of approval.
                     </span>
                    </span>
                    <span *ngIf="detail?.outcomeCheck && detail?.outcomeRejected && detail?.insufficientBalance && !currentUser?.allocated">
                      The deposit amount balance needs to be increased to cover the confirmed cost of this task.<br/> Please top up and try again.
                    </span>
                    <span *ngIf="detail?.outcomeCheck && detail?.outcomeRejected && detail?.insufficientBalance && currentUser?.allocated">
                      There is insufficient task balance to execute this task.<br/> Please work with your superuser or the budget-responsible person to top up the task balance.
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="cloudcover">
                  <th mat-header-cell *matHeaderCellDef>Cloud Cover</th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="firstcapture">
                  <th mat-header-cell *matHeaderCellDef>First Capture <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="lastcapture">
                  <th mat-header-cell *matHeaderCellDef>Last Capture <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="sensorcost">
                  <th mat-header-cell *matHeaderCellDef>Sensor Cost</th>
                  <td mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container matColumnDef="oprtyTask">
                  <th *matHeaderCellDef mat-header-cell>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index" style="padding-left: 0px !important;margin-left: -6px;">
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="feeds">
                  <th mat-header-cell *matHeaderCellDef>Feeds</th>
                  <td  mat-cell *matCellDef="let element">
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      class="retask-tooltip-trigger"
                      [matTooltip]="getTaskRetaskTooltip(detail, element) || 'Sensor-level retasking is not available for this request.'"
                      [matTooltipDisabled]="false"
                    >
                      <button
                        class="btn btn-gray retask-button sensor-retask-button"
                        [disabled]="true"
                        [class.disabledButton]="true"
                      >
                        <mat-icon class="retask-button-icon" aria-hidden="true">autorenew</mat-icon>
                        Re-Task
                      </button>
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td class="status-color" mat-cell *matCellDef="let element">
                  </td>
                </ng-container>

                <ng-container *ngIf="currentUser?.permission_based" matColumnDef="previousActor">
                  <th mat-header-cell *matHeaderCellDef>Previous Actor</th>
                  <td class="status-color" mat-cell *matCellDef="let element">
                  </td>
                </ng-container>
                <ng-container matColumnDef="questionName">
               <th mat-header-cell *matHeaderCellDef> Question Name </th>
               <td mat-cell *matCellDef="let row">
                 </td>
                </ng-container>

                <ng-container matColumnDef="questionId">
                <th mat-header-cell *matHeaderCellDef>Question ID</th>
                <td mat-cell *matCellDef="let row"  style="text-align: center;">
                  <span *ngIf="detail?.outcomeCheck && !detail?.outcomeRejected">We are tasking in the background. The platform is automatically checking
                    across multiple operators.</span>
                  <span *ngIf="detail?.taskStrategy === 'Feed Based' && detail?.outcomeRejected">
                    We could not find an operator for the data required to answer your
                    question. <br/>Please change the time of interest (TOI) and try again.
                  </span>
                </td>
                </ng-container>

                <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef>Cost</th>
                <td mat-cell *matCellDef="let element">
                </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="getInnerNameDisplayColumns(detail, detail.request)"></tr>
                <tr mat-row *matRowDef="let row; columns: getInnerNameDisplayColumns(detail, detail.request)"></tr>
              </table>

              
             
              <div class="footer-style" *ngIf="detail?.repeatFrequency !== 'Days'">
                <div class="text-style">
                </div>
                <div class="inner-table-footer">
                  <span *ngIf="detail?.feasibilityTask">
                    <button (click)="cancelOpportunities(detail)" class="btn btn-gray"
                      [disabled]="selectedTasks?.length === 0 || cancelFeasibility">
                      <span *ngIf="selectedTasks.length <= 1">Cancel Opportunity</span>
                      <span *ngIf="selectedTasks.length > 1">Cancel Opportunities</span>
                    </button>
                  </span>
                  <span *ngIf="detail.status !== 'canceled'">
                    <button (click)="cancelTask(detail, i,'sensor')" class="btn btn-gray" [disabled]="selectedTasks?.length === 0 || detail?.taskStrategy === 'Task From Collection' || !this.currentUser?.user_enabled || (this.rule === 'rule-3' && this.iscueing) || ((this.tipAndCueBasedOn === 'Feeds' || this.tipAndCueBasedOn === 'Observation' ) && this.iscueing) || cancelWeatherexOrdered">
                      <span *ngIf="selectedTasks.length <= 1 && detail?.taskStrategy !== 'Feed Based'">Cancel Sensor</span>
                      <span *ngIf="selectedTasks.length <= 1 && detail?.taskStrategy === 'Feed Based'">Cancel Question</span>
                      <span *ngIf="selectedTasks.length > 1">Cancel Sensors</span>
                    </button>
                  </span>
                  <button [disabled]="
                              selectedTasks?.length === 0 ||
                                  detail.orderStatus ||
                                  detail.greenCount === 0 || detail?.feasibilityTask || orderPending ||
                                  detail?.taskStrategy === 'Task From Collection' ||
                                  (currentUser?.permission_based && !currentUser?.permissions.includes(3))
                                  || !this.currentUser?.user_enabled || selectedSensors?.length === 0
                                " (click)="addToCart(detail,'cart')" class="btn btn-gray">
                    Add to Cart
                  </button>
                  <button (click)="checkout(detail, i)" [ngClass]="
                  (selectedTasks?.length === 0  || detail.orderStatus || detail.completed === 0 || orderPending || detail?.taskStrategy === 'Task From Collection'
                    || (currentUser?.permission_based && !currentUser?.permissions.includes(3)) || !this.currentUser?.user_enabled || selectedSensors.length === 0
                  ) ? 'btn btn-gray' : 'btn btn-black'
                                " [disabled]="
                                selectedTasks?.length === 0  ||
                                  detail.orderStatus ||
                                  detail.greenCount === 0 || orderPending ||
                                  detail?.taskStrategy === 'Task From Collection' || 
                                  (currentUser?.permission_based && !currentUser?.permissions.includes(3))
                                  || !this.currentUser?.user_enabled || selectedSensors?.length === 0
                                ">
                    Proceed to Pay
                  </button>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            matRipple
            class="element-row"
            [class.expanded]="expandedElement == row.id"
            (click)="deselect(row); toggleRow(row)"
          ></mat-row>
          <mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="
              row.id == expandedElement ? 'expanded' : 'collapsed'
            "
            style="overflow: hidden"
          >
          </mat-row>
        </table>
        <app-notask
          *ngIf="tableDataLength === 0"
          [data]="load"
          [allTask]="allTask"
        ></app-notask>
      </section>

    </div>
  </div>
</div>
</div>